import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=5fd46c44&"
import script from "./AdminHeader.vue?vue&type=script&lang=ts&"
export * from "./AdminHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports